(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    (function () {
    const toolbar = document.querySelector('[data-collection-toolbar]');
    if (!toolbar) return;

    const toggle = toolbar.querySelector('[data-collection-filters-toggle]');
    const panel = toolbar.querySelector('[data-collection-filters-panel]');
    const sortSelect = toolbar.querySelector('[data-collection-sort]');
    const sortHidden = toolbar.querySelector('[data-collection-sort-hidden]');
    const form = toolbar.querySelector('#collection-filters-form');

    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        if (form) {
          if (sortHidden) {
            sortHidden.remove();
          }
          form.submit();
          return;
        }

        const url = new URL(sortSelect.dataset.collectionUrl, window.location.origin);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    const header = document.querySelector('.site-header');
    const panelsWrap = document.querySelector('[data-mega-panels]');
    if (!header || !panelsWrap) return;

    const triggers = header.querySelectorAll('[data-mega-trigger]');
    const panels = panelsWrap.querySelectorAll('[data-mega-panel]');
    let closeTimer = null;
    let activePanel = null;

    function loadDeferredImages(panel) {
      panel.querySelectorAll('img[data-mega-img][data-src]').forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }

    function closeAll() {
      panelsWrap.hidden = true;
      panels.forEach((panel) => {
        panel.hidden = true;
      });
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('is-mega-nav-open');
      activePanel = null;
    }

    function openPanel(panelId, trigger) {
      closeAll();
      const panel = panelsWrap.querySelector(`[data-mega-panel="${panelId}"]`);
      if (!panel) return;

      panelsWrap.hidden = false;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-mega-nav-open');
      loadDeferredImages(panel);
      activePanel = panelId;
    }

    triggers.forEach((trigger) => {
      const item = trigger.closest('[data-mega-item]');
      const panelId = item ? item.dataset.megaItem : null;
      if (!panelId) return;

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeAll();
        } else {
          openPanel(panelId, trigger);
        }
      });

      item.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        openPanel(panelId, trigger);
      });

      item.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(closeAll, 160);
      });
    });

    panelsWrap.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
    });

    panelsWrap.addEventListener('mouseleave', () => {
      closeTimer = window.setTimeout(closeAll, 160);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        closeAll();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-header-search]');
    if (!root) return;

    const searchUrl = root.dataset.searchUrl;
    const resultsSection = root.dataset.resultsSection;
    const debounceMs = Number(root.dataset.debounce) || 350;
    const minChars = Number(root.dataset.minChars) || 2;
    const allowedSections = new Set(['predictive-search-results']);

    if (!allowedSections.has(resultsSection)) return;

    const openButton = root.querySelector('[data-header-search-open]');
    const dialog = root.querySelector('[data-header-search-dialog]');

    if (dialog && dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    const closeTargets = dialog.querySelectorAll('[data-header-search-close]');
    const form = dialog.querySelector('[data-header-search-form]');
    const input = dialog.querySelector('[data-header-search-input]');
    const resultsWrap = dialog.querySelector('[data-header-search-results]');
    const clearButton = dialog.querySelector('[data-header-search-clear]');
    const status = dialog.querySelector('[data-header-search-status]');

    let debounceTimer = null;
    let abortController = null;
    let lastFocus = null;

    function setLoading(isLoading) {
      resultsWrap.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      status.textContent = isLoading ? root.dataset.loading : '';
    }

    function buildUrl(query) {
      const params = new URLSearchParams();
      params.set('section_id', resultsSection);
      params.set('q', query);
      params.set('type', 'product');
      return `${searchUrl}?${params.toString()}`;
    }

    function extractPanel(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-predictive-search-panel]');
    }

    function updateViewAllHref(query) {
      const viewAll = resultsWrap.querySelector('[data-predictive-view-all]');
      if (viewAll && query) {
        viewAll.href = `${searchUrl}?q=${encodeURIComponent(query)}&type=product`;
      }
    }

    async function fetchResults(query) {
      if (abortController) {
        abortController.abort();
      }

      abortController = new AbortController();
      setLoading(true);

      try {
        const response = await fetch(buildUrl(query), {
          signal: abortController.signal,
        });

        if (!response.ok) {
          throw new Error('Search request failed');
        }

        const html = await response.text();
        const nextPanel = extractPanel(html);

        if (nextPanel) {
          const currentPanel = resultsWrap.querySelector('[data-predictive-search-panel]');
          if (currentPanel) {
            currentPanel.replaceWith(nextPanel);
          } else {
            resultsWrap.appendChild(nextPanel);
          }
          updateViewAllHref(query);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        setLoading(false);
      }
    }

    function runSearch(query) {
      const trimmed = query.trim();
      input.setAttribute('aria-expanded', trimmed.length >= minChars ? 'true' : 'false');
      clearButton.hidden = trimmed.length === 0;

      if (trimmed.length < minChars) {
        return;
      }

      fetchResults(trimmed);
    }

    function openDialog() {
      lastFocus = document.activeElement;
      dialog.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-header-search-open');
      document.body.style.overflow = 'hidden';
      window.setTimeout(() => input.focus(), 0);
    }

    function closeDialog() {
      dialog.hidden = true;
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-header-search-open');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    openButton.addEventListener('click', openDialog);

    closeTargets.forEach((target) => {
      target.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !dialog.hidden) {
        closeDialog();
      }
    });

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => {
        runSearch(input.value);
      }, debounceMs);
    });

    form.addEventListener('submit', (event) => {
      const trimmed = input.value.trim();
      if (trimmed.length < minChars) {
        event.preventDefault();
        return;
      }
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      clearButton.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.focus();
      fetchResults('');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
